import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, Optional} from "@angular/core";
import {FormControl} from "@angular/forms";
import {Observable, Subscription} from "rxjs";
import {EntityData, EntityModel} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-edit-collection-validation",
    styleUrls: ["./edit-collection-validation.component.scss"],
    templateUrl: "./edit-collection-validation.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditCollectionValidationComponent implements OnDestroy {
    private _validationFormControl: FormControl;
    @Input() entityPath: string;

    private _data: any[];
    private changeSubscription: Subscription;
    private statusChangeSubscription: Subscription;

    constructor(private changeDetectorRef: ChangeDetectorRef, @Optional() private entityModel: EntityModel<any>) {
    }

    get validationFormControl(): FormControl {
        return this._validationFormControl;
    }

    @Input()
    set validationFormControl(value: FormControl) {
        this._validationFormControl = value;

        if (this.statusChangeSubscription) {
            this.statusChangeSubscription.unsubscribe();
        }

        this.statusChangeSubscription = this._validationFormControl.statusChanges.subscribe(() => {
            this.changeDetectorRef.markForCheck();
        });
    }

    get data(): any[] {
        return this._data;
    }

    @Input()
    set data(value: any[]) {
        this._data = value;
        if (this.changeSubscription) {
            this.changeSubscription.unsubscribe();
        }

        this._validationFormControl.patchValue(value, {onlySelf: true})

        if (this.entityPath && this.entityModel) {
            const collectionChange: Observable<EntityData<any>[]> = this.entityModel.$collectionChanged(this.entityPath);
            if (collectionChange) {
                collectionChange.subscribe((data) => {
                    if (this._validationFormControl && data) {
                        this._validationFormControl.patchValue(data, {onlySelf: true})
                    }
                });
            }
        }
    }

    ngOnDestroy(): void {
        if (this.changeSubscription) {
            this.changeSubscription.unsubscribe();
        }
        if (this.statusChangeSubscription) {
            this.statusChangeSubscription.unsubscribe();
        }
    }
}
